import React, { useCallback, useState } from "react";
import { graphql, useMutation } from "react-relay";
import { UserLoggedInNavigatorScreenProps } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";
import { WidgetTaskCollectionSettingsNavigator } from "./WidgetTaskCollectionSettings/WidgetTaskCollectionSettingsNavigator";
import { WidgetTaskCollectionPreview } from "./WidgetTaskCollectionPreview";
import { WATaskCollectionMutation } from "./__generated__/WATaskCollectionMutation.graphql";
import { WidgetScreen } from "../../common/WidgetScreen";
import {
  WidgetTaskCollectionContext,
  WidgetTaskCollectionTask,
} from "./WidgetTaskCollectionContext";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";

export const WATaskCollection = withWebModal(WATaskCollectionC, true);
function WATaskCollectionC(
  props: UserLoggedInNavigatorScreenProps<"WidgetAddTaskCollection">
) {
  const [title, setTitle] = useState<string>("");
  const [selectedTasks, setSelectedTasks] = useState<
    WidgetTaskCollectionTask[]
  >([]);

  const [createWidgetTaskCollection, loading] =
    useMutation<WATaskCollectionMutation>(graphql`
      mutation WATaskCollectionMutation(
        $storecastId: ID!
        $input: CreateWidgetTaskCollectionInput!
      ) {
        dashboard(dashboardId: $storecastId) {
          createWidgetTaskCollection(widget: $input) {
            id
          }
        }
      }
    `);

  const onCreate = useCallback(() => {
    createWidgetTaskCollection({
      variables: {
        storecastId: props.route.params.storecastId,
        input: {
          positionX:
            props.route.params.position.x + props.route.params.position.c * 2,
          positionY: props.route.params.position.y,
          tasks: selectedTasks
            .slice()
            .sort((a, b) => (a.ordinal > b.ordinal ? 1 : -1))
            .map((t) => ({
              sectionId: t.sectionId,
              taskId: t.id,
            })),
          title,
        },
      },
      onCompleted: () => {
        props.navigation.pop(2);
      },
      onError: (e) => {
        console.log("error: ", e);
      },
    });
  }, [
    createWidgetTaskCollection,
    props.navigation,
    props.route.params.position.c,
    props.route.params.position.x,
    props.route.params.position.y,
    props.route.params.storecastId,
    selectedTasks,
    title,
  ]);

  return (
    <WidgetTaskCollectionContext.Provider
      value={{ selectedTasks, setSelectedTasks, setTitle, title }}
    >
      <WidgetScreen
        preview={
          <WASizePreview
            unitSize={props.route.params.unitSize}
            onCreate={onCreate}
            loading={loading}
            maxSize={props.route.params.maxSize}
            widgetSizes={[{ w: 2, h: 1 }]}
          >
            <WidgetTaskCollectionPreview
              storecastId={props.route.params.storecastId}
            />
          </WASizePreview>
        }
        settings={
          <WidgetTaskCollectionSettingsNavigator
            storecastId={props.route.params.storecastId}
            onCancel={props.navigation.goBack}
          />
        }
      />
    </WidgetTaskCollectionContext.Provider>
  );
}
